<template lang="pug">
  .analyze-complaint
    .no-print.toolbar
      .mobile-title
        span.mobile-title__number.semibold 06
        span Анализ востребованных мест размещения отходов
      .line
        h1.title {{$translate('Анализ востребованных мест размещения отходов')}}
    .map-layer.map.absolute(ref="map" v-once)
    .legend(:class="showMapLegend ? 'opened' : 'closed'" )
      e-perfect-scrollbar
        .legend__head(@click="showMapLegend = !showMapLegend")
          .legend__title Фильтр
          button.reset-btn.legend__close(v-if="showMapLegend")
          button.reset-btn.legend__open(v-else)
        .legend__group
          .legend__type
            label.semibold Указывать данные обращений
          .legend__small-group
            e-checkbox-multi(
              :options="options"
              :model="fields"
              name="date"
              tabView="null"
              labelClassName="display-block"
              @change="changeDate"
            )
</template>

<script>
import L from 'leaflet'
import * as turf from '@turf/turf'

import { REGION_CONFIG } from '@/config/regions'
import { TILE_LAYER } from '@/config/map'
import BorderDrawer from '@/utils/map/BorderDrawer'
import { unauthorized } from '@/api/api-endpoints'
import { COLORS } from '@/utils'
import timeHelper from '@/app/routes/utils/timeHelper'

export default {
  name: 'AnalyzeComplaint',
  data() {
    return {
      map: null,
      circleLayer: null,
      showMapLegend: true,
      options: [
        {
          id: 'last-week',
          filter: 'getLastWeek',
          name: 'За последнюю неделю',
        },
        {
          id: 'last-month',
          filter: 'getLastMonth',
          name: 'За последний месяц',
        },
        {
          id: 'last-three-month',
          filter: 'getLastThreeMonth',
          name: 'За последние 3 месяца',
        },
        {
          id: 'last-year',
          filter: 'getLastYear',
          name: 'За последний год',
        },
        {
          id: 'all',
          name: 'За всё время',
        },
      ],
      fields: {
        date: ['all'],
      },
      complaints: [],
      filteredComplaints: [],
    }
  },
  methods: {
    async initMap() {
      this.map = L.map(this.$refs.map, {
        center: REGION_CONFIG.map.center,
        zoom: REGION_CONFIG.map.zoom,
        minZoom: REGION_CONFIG.map.minZoom,
        maxZoom: 18,
      })

      L.tileLayer(TILE_LAYER).addTo(this.map)

      this.borderDrawer = new BorderDrawer(this.map, this)
      this.borderDrawer.drawAll(REGION_CONFIG.polygon, [])
    },
    drawComplaints() {
      const objects = []
      this.circleLayer.clearLayers()
      this.filteredComplaints.forEach((item) => {
        const coordinates = JSON.parse(item.geo_json_circle).coordinates
        let isIntersect = false
        let count = 0
        this.filteredComplaints.forEach((other) => {
          const otherCoordinates = JSON.parse(other.geo_json_circle).coordinates

          isIntersect = turf.booleanIntersects(
            turf.polygon(coordinates),
            turf.polygon(otherCoordinates)
          )
          if (isIntersect) count++
        })
        objects.push({
          ...item,
          coordinates,
          count,
        })
      })
      objects.forEach((item) => {
        let color = COLORS.green
        if (item.count === 2) {
          color = COLORS.yellow
        }
        if (item.count > 2) {
          color = COLORS.red
        }
        const getGeoJson = L.circle([item.latitude, item.longitude], {
          color,
          radius: 1500,
          fillColor: color,
          weight: 1,
        })
        this.circleLayer.addLayer(getGeoJson)
      })
    },
    async getComplaints() {
      this.complaints = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: unauthorized.complaint(),
        })
      ).data.data
      this.filteredComplaints = [...this.complaints]
      this.circleLayer = L.featureGroup()
      this.map.addLayer(this.circleLayer)
      this.drawComplaints()
    },
    changeDate(e) {
      this.fields.date = []
      if (e.target.checked) {
        this.fields.date = [e.target.value]
      }
      const complaints = [...this.complaints]
      this.options.forEach((item) => {
        if (e.target.value === item.id && item.filter) {
          this.filteredComplaints = complaints.filter((el) => {
            return (
              timeHelper.getMomentDate(el.created_at) >=
              timeHelper[item.filter]()
            )
          })
        }
      })
      if (!this.fields.date.length || e.target.value === 'all') {
        this.fields.date = ['all']
        this.filteredComplaints = [...this.complaints]
      }
      this.drawComplaints()
    },
  },
  mounted() {
    this.initMap()
  },
  created() {
    this.getComplaints()
  },
}
</script>
<style scoped lang="scss"></style>
